import React, { useEffect, useState } from "react";
import FoodSections from "../components/FoodSections";
import { useLocation } from "react-router-dom";
import apiClient, { generateUrl } from "../api/axios";
import { getRecipeParamsForAll } from "../util/helper";
import ClipLoader from "react-spinners/ClipLoader";

const RecipePage = () => {
  const location = useLocation();
  const [recipeList, setRecipeList] = useState([]);
  const [nextPageUrl, setNextPageUrl] = useState(undefined);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentCount, setCurrentCount] = useState(20);
  const [totalCount, setTotalCount] = useState(10000);
  const [queryParams, setQueryParams] = useState(
    new URLSearchParams(location.search)
  );

  const cuisineType = queryParams.get("cuisineType") ?? undefined;
  const searchString = queryParams.get("q") ?? undefined;
  const title =
    cuisineType === undefined
      ? searchString === undefined
        ? "Recipes"
        : `"${searchString}" Recipes`
      : `${cuisineType} Cuisine Recipes`;

  useEffect(() => {
    console.log("items loaded");
    loadMoreItems();
  }, [page]);

  const resetComponent = () => {
    setRecipeList([]);
    setNextPageUrl(undefined);
    setLoading(false);
    setHasMore(true);
    setCurrentCount(20);
    setTotalCount(10000);
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    setQueryParams(new URLSearchParams(location.search));
    resetComponent();
    console.log("component reset");
  }, [location.search]);

  const loadMoreItems = async () => {
    setLoading(true);

    try {
      const url =
        nextPageUrl === undefined
          ? generateUrl("", getRecipeParamsForAll(cuisineType, searchString))
          : nextPageUrl;
      const data = await apiClient.get(url);

      setRecipeList((prevItems) => [...prevItems, ...data.hits]);
      setNextPageUrl(data?._links?.next?.href);
      setHasMore(data.hits.length > 0);
      setCurrentCount((curr) => data?.to + 20);
      setTotalCount(data?.count);
    } catch (error) {
      console.error("Error fetching items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    if (loading || !hasMore) return;

    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [loading, hasMore]);

  return (
    <>
      <FoodSections recipeList={recipeList} title={title} />
      {loading && (
        <div className="flex justify-center flex-col items-center gap-5 my-8">
          <ClipLoader />
          <p>
            Loading {currentCount} of {totalCount} recipies
          </p>
        </div>
      )}
      {!hasMore && (
        <div className="flex justify-center flex-col items-center gap-5 my-8">
          No more items to load
        </div>
      )}
    </>
  );
};

export default RecipePage;
